var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"size":"small","placeholder":"请选择","multiple":_vm.multiple,"clearable":_vm.clearable},on:{"change":_vm.handleChange},model:{value:(_vm.check_id),callback:function ($$v) {_vm.check_id=$$v},expression:"check_id"}},_vm._l((_vm.products),function(item,key){return _c('el-option',{key:key,attrs:{"label":item.name,"value":item.id}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50272162","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/Product.vue
// module id = 1226
// module chunks = 0